export default __webpack_public_path__ + "locales/pt/ChangeEmailDialog.json?hash=61826fdff61afb6530adb5b5c6d6e57e";